import { render, staticRenderFns } from "./EmoticonDisplay.vue?vue&type=template&id=9bc2a5f4&"
import script from "./EmoticonDisplay.vue?vue&type=script&lang=ts&"
export * from "./EmoticonDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./EmoticonDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports